import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { v4 as uuidv4 } from "uuid";
import { environment } from "../../../environments/environment";
import { SILENT_HTTP_CONTEXT } from "../../shared/utils/silent-http.util";

interface ApiResponseBody<T> {
  body?: T;
  message?: string;
}

/**
 * Hand-written on purpose, like CompanyWhatsappAdminApiService next door: this endpoint
 * (CompanyApi#getMyAvatarUrl) is new on waba and the checked-in swagger is only regenerated
 * from a live server, so `npm run gn-waba` cannot produce it yet. Delete this file and use the
 * generated CompanyApiService once waba is redeployed and the swagger is refreshed.
 */
@Injectable({ providedIn: "root" })
export class MyAvatarApiService {
  private readonly url = `${environment.wabaApiUrl}/v1/api/ui/company/my-avatar`;

  constructor(private http: HttpClient) {}

  /** The signed-in administrator's own profile photo URL, or undefined (classic sign-up / none). */
  getMyAvatarUrl(): Observable<string | undefined> {
    return this.http
      .get<ApiResponseBody<string>>(this.url, {
        headers: new HttpHeaders({ "x-api-requestId": uuidv4(), "x-api-canal": "web" }),
        context: SILENT_HTTP_CONTEXT,
      })
      .pipe(map((response) => response?.body ?? undefined));
  }
}
